export const CHANGE_MODEL = "CHANGE_MODEL";
